/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTypeCloudProviderVersionsSpec } from './rolloutTypeCloudProviderVersionsSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface RolloutTypeServiceTypesSpec { 
    service_type: ServiceTypeEnum;
    cloud_provider_versions: Array<RolloutTypeCloudProviderVersionsSpec>;
}
export namespace RolloutTypeServiceTypesSpec {
}


